var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.video.type === "YouTube"
    ? _c(
        "div",
        { staticClass: "video", class: _vm.styleClasses, style: _vm.maxWidth },
        [
          _c("div", { staticClass: "relative aspect-video" }, [
            _c("iframe", {
              staticClass: "aspect-video w-full",
              staticStyle: { "aspect-ratio": "16/9" },
              attrs: {
                title: "youtube video",
                src: "https://www.youtube.com/embed/" + _vm.video.id,
              },
            }),
          ]),
        ]
      )
    : _vm.video.type === "Asset"
    ? _c(
        "div",
        {
          staticClass: "video",
          class: _vm.styleClasses,
          style: _vm.maxWidth + _vm.width,
        },
        [
          _c(
            "video",
            {
              attrs: {
                playsinline: "",
                autoplay: "",
                muted: "",
                preload: "auto",
                loop: "",
                "data-not-lazy": _vm.lazy,
              },
              domProps: { muted: true },
            },
            [
              _c("source", { attrs: { src: _vm.video.video.fields.file.url } }),
              _vm._v(" "),
              _c("track", { attrs: { kind: "captions" } }),
            ]
          ),
        ]
      )
    : _vm.video.type === "Mobile Device" || _vm.video.type === "Desktop Device"
    ? _c("div", { class: _vm.deviceClasses + _vm.styleClasses }, [
        _c(
          "video",
          {
            attrs: {
              playsinline: "",
              autoplay: "",
              muted: "",
              preload: "auto",
              loop: "",
              "data-not-lazy": _vm.lazy,
            },
            domProps: { muted: true },
          },
          [
            _c("source", { attrs: { src: _vm.video.video.fields.file.url } }),
            _vm._v(" "),
            _c("track", { attrs: { kind: "captions" } }),
          ]
        ),
      ])
    : _vm.video.type === "Vimeo"
    ? _c("div", { ref: "vimeo", staticClass: "video", style: _vm.maxWidth }, [
        _c("div", { staticClass: "relative video--frameless" }, [
          _c("iframe", {
            staticClass: "block absolute h-full w-full",
            attrs: {
              id: "vimeo-video",
              src: `https://player.vimeo.com/video/${_vm.video.id}?autoplay=1&loop=1&muted=1&portrait=0&controls=${_vm.videoControls}&title=0`,
              frameborder: "0",
              allow: "autoplay; fullscreen",
              allowfullscreen: "",
            },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }